import script from "./WarehouseReceiptSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseReceiptSummary.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QCard,QCardSection,QLinearProgress,QSeparator});
